import { SeparationType } from "../../../enums/SeparationType";
import { ShopifyFulfillmentStatus } from "../../../enums/ShopifyFulfillmentStatus";
import { LinkedToOrderBatchOption } from "../../../enums/LinkedToOrderBatchOption";
import { BaseFilterInput } from "../../../common-models/BaseFilterInput";
import { OrderAlertType } from "../../../enums/OrderAlertType";
import { OrderShippingLineState } from '../../../enums/OrderShippingLineState';
import { FramesQuantity } from '../../../enums/FramesQuantity';

export class FilterOrderInput extends BaseFilterInput {
  frontVersion?: number | null;
  separationType: SeparationType = SeparationType.Default;
  expressOrder?: boolean;
  linkedToOrderBatchOption: LinkedToOrderBatchOption = LinkedToOrderBatchOption.All;
  orderBatchId?: number;
  number?: number;
  numbers?: string;
  customerName?: string;
  customerEmail?: string;
  stateIds?: string;
  statePrescriptionId?: number;
  statePrescriptionIds?: string;
  fulfillmentStatus?: ShopifyFulfillmentStatus;
  isOpened?: boolean | null = null;
  authorizationStartDate?: any;
  authorizationEndDate?: any;
  specialTag?: string;
  secondsDelayToFilter?: number;
  orderAlertType?: OrderAlertType;
  userId?: number | null;
  locationId?: number | null;
  sellerId?: number | null;
  sellerName?: string | null;
  orderShippingLineState?: OrderShippingLineState;
  orderId?: number;
  stateIdsForUserProfile?: string;
  deliveryDeadlineStartDate?: any;
  deliveryDeadlineEndDate?: any;
  deliveryStartDate?: any;
  deliveryEndDate?: any;
  lensMaterialName?: string | null;
  lensClassName?: string | null;
  fulfilledBy?: string | null;
  fulfillmentLocationIds?: number[] | null;
  includesCrossChannelSale?: boolean | null;
  onlyCrossChannelSale?: boolean | null;
  originedBy?: string | null;
  ignoreDefaultUserProfileFilters?: boolean | null;
  considerDefaultUserProfileFilters?: boolean | null;
  salesTypeFilter?: string | null;
  framesQuantity?: FramesQuantity;
}